export default "/images/GraphMode.svg?f2228c40339784d40447d6d17c0ba75e";